import { render } from "./Tile.vue?vue&type=template&id=19e5e732&lang=pug"
import script from "./Tile.vue?vue&type=script&lang=js"
export * from "./Tile.vue?vue&type=script&lang=js"

import "./Tile.vue?vue&type=style&index=0&id=19e5e732&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__